// modules/land-for-sale/elements/PlanLotsContainer.js
import React        from 'react';

class PlanLotsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {active: false};

        // this.showHoverEvent = this.showHoverEvent.bind(this);
        // this.hideHoverEvent = this.hideHoverEvent.bind(this);

        // this.props.messenger.subscribe("a_"+this.props.element.id, this.showHoverEvent);
        // this.props.messenger.subscribe("c_"+this.props.element.id, this.hideHoverEvent);
    }

    // componentWillUnmount() {
    // 	this.props.messenger.remove("a_"+this.props.element.id);
    //  this.props.messenger.remove("c_"+this.props.element.id);
    // }
    //
    // showHoverEvent() {
    //      this.setState({active:true});
    // }
    //
    // hideHoverEvent() {
    //     this.setState({active:false});
    // }

    render() {
        var divclasses = "landforsale-sold";
        // if (this.state.active) {
        //     divclasses += " active";
        // }
        var thisstyle = {};

        if(this.props.element.himage.length > 0){
            divclasses = "image " + divclasses;
            return(
                <div className="landforsale-map_lot_hover">
                    <img width={this.props.width} height={this.props.height} src={this.props.element.himage} role="presentation"  className={divclasses} style={thisstyle}  />
                </div>
            )
        }else{
            return(
                <div className="landforsale-map_lot_hover">
                    <svg width={this.props.width} height={this.props.height}>
                        <polygon points={this.props.element.coords} className={divclasses} style={thisstyle}  />
                    </svg>
                </div>
            )
        }
    }
}
export default PlanLotsContainer;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanSoldOutline.js
 **/